import { ComparePage } from '@/components/marketing/compare-page'

export function CompareObsidianPage() {
  return (
    <ComparePage
      contentKey="compareObsidian"
      path="/compare/obsidian"
      otherLabel="Obsidian"
      relatedKeys={['comparePerplexity', 'whatIsKnowledgeGraph', 'useCasesResearchers']}
    />
  )
}
